const EXPIRY_TYPE_OPTIONS: { label: string; value: boolean }[] = [
  { label: "非即期品", value: false },
  { label: "即期品", value: true },
];

export default EXPIRY_TYPE_OPTIONS;
